import styled from '@emotion/styled'
import {theme} from '../../../../../core/theme'

export const CatalogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: ${theme.palette.neutral[0]};
  // gap: 8px;
  // padding: 10px;
  border-radius: 12px;
  border: 1px solid #cedcf9;
  height: 100%;
  overflow: hidden;
`

export const ProductsPanel = styled.div`
  min-width: 0;
  width: 100%;
  background: ${theme.colors.bg.primary};
  border-radius: ${theme.radii.lg2};
  padding: ${theme.space[2.5]};
  position: relative;
`

export const CatalogLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.radii.lg2};
`
